<template>
  <div class="it">
    <nuxt-link
      class="it__card child"
      to="/catalog/programmirovanie-dlya-detej/nachinayushchim"
    >
      <div class="it__card-bg" />

      <p class="it__card-subtitle">
        7-13 лет
      </p>

      <h6 class="it__card-title">
        <img
          src="/v2/header/old/dropdown/it/arrow.svg"
          alt="arrow"
        >
        погрузитесь в мир программирования без определенных
        знаний и откройте путь для будущей карьеры
      </h6>

      <ul class="it__card-list">
        <li
          v-for="item of childSubjects"
          :key="item"
        >
          {{ item }}
        </li>
      </ul>
    </nuxt-link>

    <nuxt-link
      class="it__card teen"
      to="/catalog/programmirovanie-dlya-detej/prodvinutym"
    >
      <div class="it__card-bg" />

      <p class="it__card-subtitle">
        14-18 лет
      </p>

      <h6 class="it__card-title">
        <img
          src="/v2/header/old/dropdown/it/arrow.svg"
          alt="arrow"
        >
        познакомьтесь с основами разработки и расширьте
        свои знания и навыки в программировании
      </h6>

      <ul class="it__card-list">
        <li
          v-for="item of teenSubjects"
          :key="item"
        >
          {{ item }}
        </li>
      </ul>
    </nuxt-link>

    <div
      class="it__card future"
      role="button"
      tabindex="0"
      @click="toggleFreeITFutureLead"
    >
      <div class="it__card-bg" />

      <h6 class="it__card-title">
        <img
          src="/v2/header/old/dropdown/it/arrow.svg"
          alt="arrow"
        >
        Код будущего
      </h6>

      <p class="it__card-text">
        Бесплатное обучение востребованным
        IT-профессиям для школьников 8–11 классов
      </p>
    </div>

    <div
      class="it__free"
      role="button"
      tabindex="0"
      @click="toggleFreeITLead"
    >
      <div class="it__free-bg">
        <img
          src="/v2/header/old/dropdown/it/free.png"
          alt="heart"
          class="it__free-bg--image"
        >
        <img
          src="/v2/header/old/dropdown/it/free-mobile.png"
          alt="heart"
          class="it__free-bg--image-mobile"
        >
      </div>

      <img
        src="/v2/header/old/dropdown/it/free-title.svg"
        alt="бесплатный первый урок"
        class="it__free-title"
      >
      <p class="it__free-text">
        Посетите первый урок любого курса, познакомьтесь
        с учителями и оцените качество обучения
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DropdownITContent',
  data: () => ({
    childSubjects: ['Python', 'Scratch', 'Roblox', 'Minecraft', 'CoSpaces', 'и другие'],
    teenSubjects: ['Python', 'Scratch', 'JavaScript', 'Java', 'С++', 'CoSpaces'],
  }),

  methods: {
    ...mapActions('headerModals', [
      'toggleFreeITLead',
      'toggleFreeITFutureLead',
      'toggleFreeITProgrammingLead',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.it {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr 0.348fr 0.652fr;
  grid-gap: 10px;

  @media (max-width: 1220px) {
    grid-template-rows: 1fr 0.05fr 0.95fr;
  }

  @include media-down(laptop) {
    grid-template-columns: 1.5fr 1fr;
  }

  @include media-down(tablet) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }

  &__card {
    position: relative;
    padding: 20px;

    border-radius: 20px;

    cursor: pointer;

    @media (max-width: 1220px) {
      padding: 15px;
    }

    @include media-down(laptop) {
      padding: 10px;
    }

    @include media-down(tablet) {
      padding: 16px;
    }

    &-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      background-color: $header-card-bg;
      border-radius: 20px;
      box-shadow: 2px 2px 10px 0 rgba(87, 106, 135, 0.02) inset, 8px 8px 30px 0 rgba(87, 106, 135, 0.02) inset;

      transition: width .2s ease-out, height .2s ease-out, top .2s ease-out, left .2s ease-out;
    }

    &-subtitle {
      position: relative;
      z-index: 1;
      margin-bottom: 8px;

      font-variant-numeric: lining-nums proportional-nums;
      font-feature-settings: 'case' on;
      font-size: 14px;
      font-weight: 500;
      line-height: 110%;
      letter-spacing: -0.28px;
      color: $grey2;

      transition: color .2s ease-out;
    }

    &-title {
      position: relative;
      z-index: 1;
      max-width: 437px;

      font-variant-numeric: lining-nums proportional-nums;
      font-size: 20px;
      font-weight: 700;
      line-height: 110%;
      letter-spacing: -0.2px;
      text-transform: uppercase;
      color: $black-color;

      @media (max-width: 1220px) {
        font-size: 18px;
      }

      @include media-down(laptop) {
        font-size: 15px;
      }

      @include media-down(tablet) {
        font-size: 20px;
      }

      img {
        display: inline;
        transform: translateY(1.5px);

        @media (max-width: 1220px) {
          max-height: 16px;
          transform: translateY(0);
        }

        @include media-down(laptop) {
          max-height: 12px;
        }

        @include media-down(tablet) {
          max-height: 16px;
        }
      }
    }

    &-text {
      position: relative;
      z-index: 1;
      max-width: 286px;
      margin-top: 8px;

      font-variant-numeric: lining-nums proportional-nums;
      font-size: 16px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: -0.16px;
      color: $grey2;

      transition: color .2s ease-out;

      @media (max-width: 1220px) {
        font-size: 14px;
      }

      @include media-down(tablet) {
        font-size: 16px;
      }
    }

    &-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-row-gap: 11px;
      max-width: 317px;
      margin-top: 18px;

      li {
        position: relative;
        padding-left: 12px;

        font-variant-numeric: lining-nums proportional-nums;
        font-size: 14px;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.28px;
        color: $grey2;

        transition: color .2s ease-out;

        &:before {
          content: url('/v2/header/old/dropdown/it/dot.svg');
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }

    &:hover {
      .it__card-bg {
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        top: 2px;
        left: 2px;
      }
      .it__card-subtitle {
        color: $black-color;
      }
      .it__card-text {
        color: $black-color;
      }
      .it__card-list li {
        color: $black-color;
      }
    }
  }

  &__card.child {
    grid-column: 1;
    grid-row: 1;
  }
  &__card.teen {
    grid-column: 1;
    grid-row: 2 / 4;

    @include media-down(tablet) {
      grid-column: 1;
      grid-row: 2;
    }
  }
  &__card.future {
    grid-column: 2;
    grid-row: 3;

    @include media-down(tablet) {
      grid-column: 1;
      grid-row: 3;
      min-height: 138px;
    }
  }

  &__free {
    grid-column: 2;
    grid-row: 1 / 3;
    position: relative;
    overflow: hidden;

    border-radius: 20px;

    cursor: pointer;
    transition: transform .2s ease-out;

    @include media-down(tablet) {
      grid-column: 1;
      grid-row: 4;
      height: 226px;
      overflow: hidden;

      border-radius: 20px;
    }

    &-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      overflow: hidden;

      border-radius: 20px;
      background-color: $header-card-bg;

      transition: .2s ease-out;

      &--image {
        width: 100%;
        height: 100%;

        @include media-down(tablet) {
          display: none;
        }

        &-mobile {
          display: none;

          @include media-down(tablet) {
            display: block;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
      }
    }

    &-title {
      position: absolute;
      z-index: 1;
      top: 20px;
      left: 12px;

      @media (max-width: 1220px) {
        max-width: 100%;
        left: 7px;
      }

      @include media-down(laptop) {
        max-width: 90%;
        top: 10px;
      }

      @include media-down(tablet) {
        top: 16px;
      }
    }

    &-text {
      position: absolute;
      z-index: 1;
      top: 72px;
      left: 20px;
      width: 78.43%;

      font-size: 16px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: -0.16px;
      color: $grey2;

      transition: color .2s ease-out;

      @media (max-width: 1220px) {
        left: 15px;
        font-size: 14px;
      }

      @include media-down(laptop) {
        top: 62px;
        left: 10px;
      }

      @include media-down(tablet) {
        top: 68px;
        left: 16px;
        font-size: 16px;
      }
    }

    &:hover {
      .it__free-bg {
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        left: 2px;
        top: 2px;
      }
      .it__free-text {
        color: $black-color;
      }
    }
  }
}
</style>
